<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="ViewRecord" />
      <feather-icon v-if="!readOnly" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
    </div>
</template>

<script>
import { isReadOnlyUser } from "@/helpers/roleAccess.js";

export default {
  name: 'CellRendererActions',
  computed: {
    // Compte en lecture seule (Broker Status) : pas d'icône d'édition.
    readOnly () { return isReadOnlyUser() }
  },
  methods: {
    editRecord () {
        this.$router.push("/broker/quotation-edit/" + this.params.data.ref).catch(() => {})
    },
    ViewRecord () {
        this.$router.push("/broker/quotation/" + this.params.data.ref).catch(() => {})
    }
  }
}
</script>
